module.exports = __webpack_public_path__ + "img/catalogo.058fc2b3.png";